import { Controller } from '@hotwired/stimulus';
import consumer from './../channels';

export default class extends Controller {
  connect() {
    this.workspaceSyncSubscription = consumer.subscriptions.create(
      { channel: 'SlackWorkspacesSyncChannel' },
      {
        received: (_data) => {
          window.location.reload();
        },
      },
    )
  }

  disconnect() {
    if (typeof this.workspaceSyncSubscription !== 'undefined') {
      this.workspaceSyncSubscription.unsubscribe();
    }
  }
}
